import type { SVGProps } from 'react';

const FinnSquare = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.70709 1.6311H2.33924C1.94212 1.6311 1.61914 1.95667 1.61914 2.35678V22.6433C1.61914 23.0434 1.94212 23.369 2.33924 23.369H23.1942V16.2275C23.1942 8.17898 16.6954 1.6311 8.70709 1.6311Z"
            fill="#006CFB"></path>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M 25 21 H 25 V 16.2275 C 25 4.3049 15.0676 0 8.7069 0 H 2.3392 C 1.0493 0 0 1.0572 0 2.3568 V 22.6433 C 0 23.9428 1.0493 25 2.3392 25 H 25 Z M 1.6189 22.6433 V 2.3568 C 1.6189 1.9567 1.942 1.6311 2.3392 1.6311 H 8.7069 C 16.6951 1.6311 23.194 8.179 23.194 16.2275 V 23.3689 H 2.3392 C 1.942 23.3689 1.6189 23.0435 1.6189 22.6433 Z"
            fill="white"></path>
    </svg>
);

export const FinnLogo = (props: SVGProps<SVGSVGElement>) => (
    <svg width={48} height={25} viewBox="0 0 48 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M46.3812 22.6433V2.35678C46.3812 1.95667 46.0581 1.6311 45.661 1.6311H25.5332C25.1361 1.6311 24.813 1.95667 24.813 2.35678V23.3688H45.661C46.0581 23.3688 46.3812 23.0434 46.3812 22.6433Z"
            fill="#00BFFB"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.70709 1.6311H2.33924C1.94212 1.6311 1.61914 1.95667 1.61914 2.35678V22.6433C1.61914 23.0434 1.94212 23.369 2.33924 23.369H23.1942V16.2275C23.1942 8.17898 16.6954 1.6311 8.70709 1.6311Z"
            fill="#006CFB"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.61891 22.6433V2.35681C1.61891 1.9567 1.94204 1.63113 2.33916 1.63113H8.70686C16.6951 1.63113 23.194 8.17901 23.194 16.2275V23.3689H2.33916C1.94204 23.3689 1.61891 23.0435 1.61891 22.6433ZM46.3811 22.6433C46.3811 23.0435 46.0579 23.3689 45.6608 23.3689H24.8129V2.35681C24.8129 1.9567 25.1361 1.63113 25.5332 1.63113H45.6608C46.0579 1.63113 46.3811 1.9567 46.3811 2.35681V22.6433ZM45.6608 0H25.5332C24.2434 0 23.194 1.05723 23.194 2.35681V9.14134C20.5782 3.73452 15.0676 0 8.70688 0H2.33918C1.04932 0 0 1.05723 0 2.35681V22.6433C0 23.9428 1.04932 25 2.33918 25H45.6608C46.9507 25 48 23.9428 48 22.6433V2.35681C48 1.05723 46.9507 0 45.6608 0Z"
            fill="white"
        />
    </svg>
);

export const FinnFull = (props: SVGProps<SVGSVGElement>) => (
    <svg width={92} height={32} viewBox="0 0 184 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}>
        <title>FINN.no</title>
        <path fill="#06bffc" d="M179.8 58V6c0-1-.8-1.9-1.9-1.9H66c-1 0-1.9.8-1.9 1.9v53.8H178c1 0 1.8-.8 1.8-1.8"></path>
        <path fill="#0063fc" d="M22.5 4.2H6C5 4.2 4.2 5 4.2 6v52c0 1 .8 1.9 1.9 1.9H60V41.5C59.9 20.9 43.2 4.2 22.5 4.2"></path>
        <path
            fill="#fff"
            d="M178 0H66c-3.3 0-6 2.7-6 6v17.4C53.2 9.6 38.9 0 22.5 0H6C2.7 0 0 2.7 0 6v52c0 3.3 2.7 6 6 6h172c3.3 0 6-2.7 6-6V6c0-3.3-2.7-6-6-6m1.8 58c0 1-.8 1.9-1.9 1.9H64.1V6c0-1 .8-1.9 1.9-1.9h112c1 0 1.9.8 1.9 1.9v52zM4.2 58V6C4.2 5 5 4.2 6 4.2h16.5c20.6 0 37.4 16.8 37.4 37.4v18.3H6c-1-.1-1.8-.9-1.8-1.9"></path>
        <path
            fill="#fff"
            d="M110.1 21.1h-4.2c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2V22.3c0-.6-.6-1.2-1.2-1.2m-12 0H83c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2v-4h7.7c.7 0 1.2-.5 1.2-1.2v-3.2c0-.7-.5-1.2-1.2-1.2h-7.7v-4.9h9.7c.7 0 1.2-.5 1.2-1.2v-3.7c0-.5-.6-1.1-1.2-1.1m62.8 0h-4.2c-.7 0-1.2.5-1.2 1.2v9.5l-6.6-10c-.3-.4-.8-.7-1.3-.7h-3.2c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2v-9.4l6.5 9.8c.3.4.8.7 1.3.7h3.4c.7 0 1.2-.5 1.2-1.2V22.3c-.1-.6-.6-1.2-1.3-1.2m-25.4 0h-4.2c-.7 0-1.2.5-1.2 1.2v9.5l-6.6-10c-.3-.4-.8-.7-1.3-.7H119c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2v-9.4l6.5 9.8c.3.4.8.7 1.3.7h3.4c.7 0 1.2-.5 1.2-1.2V22.3c-.1-.6-.6-1.2-1.3-1.2"></path>
    </svg>
);

export default FinnSquare;
